const DEV = /^(stg|dev|sandbox|qa|staging)/;
const DEV_HOST = /.*(firebaseapp\.com|ngrok\.io|netlify\.app)/;
const LOCALHOST = /^(localhost|192|10|local)$/;
const DEV_ENV = /dev.+\.dev\.clover\.com$/;
const NA_STAGING_ENV = /staging\.clover\.com$/;
const PROD_ENV = /^(www\.)?((eu|la)\.)?clover\.com$/;
const CLOVER_HOST = /^(.*\.)?clover\.com$/;

export type Environment = 'test' | 'development' |'production';

/**
 * Is a Dev based location (stg1, dev1, firebase, etc)
 */
export const isDevEnvironment = (hostname: string = getHostname()) => {
  const isDev = DEV.test(hostname?.split('.')[0]);

  return isLocalhost(hostname) || isDev || isDevHost(hostname);
};

/**
 * Is Localhost based on hostname
 */
export const isLocalhost = (hostname: string = getHostname()) => LOCALHOST.test(hostname.split('.')[0]);

/**
 * Is a non-Clover dev host (firebase, netlify, etc)
 */
export const isDevHost = (hostname: string = getHostname()) => DEV_HOST.test(hostname);

/**
 * Is a Clover dev environment (devX.dev.clover.com)
 */
export const isCloverDevEnvironment = (hostname: string = getHostname()) => DEV_ENV.test(hostname);

/**
 * Is a Clover stage environment (stgX.dev.clover.com | staging.clover.com - NA staging)
 */
export const isCloverStagingEnvironment = (hostname: string = getHostname()) => {
  return NA_STAGING_ENV.test(hostname);
};

/**
 * Is a Clover prod environment (www.clover.com)
 */
export const isCloverProdEnvironment = (hostname: string = getHostname()) => isCloverHost(hostname) && PROD_ENV.test(hostname);

export const isCloverHost = (hostname: string = getHostname()) => CLOVER_HOST.test(hostname);

export const getHostname = () => window.location.hostname;

export const getCloverEnvironmentName = (hostname: string = getHostname()) => hostname.split('.')[0].replace(/[0-9]/g, '');

export const getCloverApiHostname = (hostname: string = getHostname()) => {
  // Handle local.dev.clover.com
  if (isCloverHost(hostname) && !isLocalhost(hostname)) return `https://${hostname}`;

  return [`${window.location.protocol}//${hostname}`, window.location.port].filter(s => !!s).join(':');
};
